/* B2B monitoring: explicit business requests only. All telemetry is allowlisted. */
(function (w) {
  'use strict';
  if (w.B2BMonitoring) return;
  var config = w.B2BMonitoringConfig || {};
  var sdk = w.Sentry;
  var enabled = false;
  var seen = typeof WeakSet === 'function' ? new WeakSet() : null;
  var keys = ('app_component environment release workflow operation route method request_id customer_id buying_mode customer_role outcome reason_code error_code upstream_service upstream_status duration_ms item_count attempt_count option_count cache_hit price_book_version pricing_status delivery_type fallback handled status_code error_details').split(' ');
  var paths = ('api apps b2b-proxy cart cart.js add.js change.js update.js clear.js checkout customer customers by-email credit check pricing current get-by-company create-checkout-discount buying-mode embellishments presets use upload-logo upload-dst price draft-orders create tax calculate calculate-cart calculate-from-draft quotes quote save get delete embellishment-request embellishment-drafts prepare company-stores master-purchaser-context experience revoke shipping_rates.json').split(' ');
  function attrs(input) {
    var out = {};
    Object.keys(input || {}).forEach(function (key) {
      var value = input[key];
      if (keys.indexOf(key) < 0) return;
      if (key === 'error_details') { if (typeof value === 'string') out[key] = diagnosticText(value); return; }
      if (key === 'customer_id' && !/^\d+$/.test(String(value))) return;
      if (typeof value === 'boolean' || (typeof value === 'number' && isFinite(value)) || (typeof value === 'string' && /^[a-zA-Z0-9_.:/ -]{1,120}$/.test(value))) out[key] = value;
    });
    return out;
  }
  function route(value) {
    try { return new URL(String(value), w.location.href).pathname.split('/').map(function (part) { return !part || paths.indexOf(part) >= 0 ? part : ':id'; }).join('/'); }
    catch (_) { return '/:unknown'; }
  }
  function diagnosticText(value) {
    if (typeof value !== 'string') return undefined;
    return value
      .replace(/\b(?:Bearer|Basic)\s+[a-zA-Z0-9._~+/=-]+/gi, '[redacted authentication]')
      .replace(/\b(?:shpat|shpca|shppa|shpss)_[a-zA-Z0-9]+\b/g, '[redacted token]')
      .replace(/\beyJ[a-zA-Z0-9_-]+\.[a-zA-Z0-9_-]+\.[a-zA-Z0-9_-]+\b/g, '[redacted token]')
      .replace(/(["']?(?:password|secret|token|api[_-]?key|authorization|cookie|session[_-]?id)["']?\s*[:=]\s*)(?:"[^"\r\n]*"|'[^'\r\n]*'|[^\s,;}]+)/gi, '$1[redacted]')
      .replace(/[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}/g, '[redacted email]')
      .replace(/https?:\/\/[^\s"'<>\[\]{}]+/g, function (value) { try { return new URL(value).origin + route(value); } catch (_) { return '[redacted URL]'; } })
      .slice(0, 8192);
  }
  function errorDetails(error) {
    return JSON.stringify({ name: error && error.name, message: diagnosticText(error && error.message) });
  }
  function scrubSpan(span) {
    var data = attrs(span.data);
    var result = { description: String(span.op || '').indexOf('http') === 0 ? route(span.description || data.route || '/:unknown') : data.operation || span.op || 'storefront.workflow', data: data };
    ['span_id', 'trace_id', 'parent_span_id', 'op', 'status', 'start_timestamp', 'timestamp', 'origin'].forEach(function (key) { if (span[key] !== undefined) result[key] = span[key]; });
    return result;
  }
  function scrub(event) {
    var out = { tags: attrs(Object.assign({}, event.contexts && event.contexts.trace && event.contexts.trace.data, event.tags)), extra: {}, contexts: {} };
    ['event_id', 'timestamp', 'start_timestamp', 'platform', 'type', 'level', 'environment', 'release', 'sdk'].forEach(function (key) { if (event[key] !== undefined) out[key] = event[key]; });
    if (event.contexts && event.contexts.trace) {
      out.contexts.trace = {};
      ['trace_id', 'span_id', 'parent_span_id', 'op', 'status'].forEach(function (key) { out.contexts.trace[key] = event.contexts.trace[key]; });
    }
    if (event.user && /^\d+$/.test(String(event.user.id))) out.user = { id: String(event.user.id) };
    if (event.request) out.request = { url: route(event.request.url), method: event.request.method };
    if (event.transaction) out.transaction = out.tags.operation || route(event.transaction);
    if (event.spans) out.spans = event.spans.map(scrubSpan);
    if (event.exception && event.exception.values) out.exception = { values: event.exception.values.map(function (exception) {
      var safe = { type: exception.type || 'Error', value: diagnosticText(exception.value) || out.tags.operation || 'storefront.unhandled' };
      if (exception.mechanism) safe.mechanism = { type: exception.mechanism.type, handled: exception.mechanism.handled };
      if (exception.stacktrace) safe.stacktrace = { frames: (exception.stacktrace.frames || []).map(function (frame) {
        var result = {};
        ['function', 'lineno', 'colno', 'in_app'].forEach(function (key) { if (frame[key] !== undefined) result[key] = frame[key]; });
        if (frame.filename) {
          try { var url = new URL(frame.filename, w.location.href); result.filename = url.origin + (/\.js$/.test(url.pathname) ? url.pathname : route(url.pathname)); } catch (_) {}
        }
        return result;
      }) };
      return safe;
    }) };
    return out;
  }
  var apiOrigins = ['https://shopifyapp.everythingsafety.com'];
  try { var configuredOrigin = new URL(config.apiUrl).origin; if (apiOrigins.indexOf(configuredOrigin) < 0) apiOrigins.push(configuredOrigin); } catch (_) {}
  var proxyPath = String(config.proxyPath || '/apps/b2b-api').replace(/\/+$/, '');
  function target(url) {
    return (apiOrigins.indexOf(url.origin) >= 0 && /^\/api(?:\/|$)/.test(url.pathname)) ||
      (url.origin === w.location.origin && (url.pathname === proxyPath || url.pathname.indexOf(proxyPath + '/') === 0));
  }
  try {
    if (config.enabled && config.dsn && !config.designMode && !/^(localhost|127\.0\.0\.1)$/.test(w.location.hostname) && sdk && sdk.init) {
      var targets = [];
      apiOrigins.forEach(function (origin) { targets.push(new RegExp('^' + origin.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '/api(?:/|\\?|$)')); });
      targets.push(new RegExp('^(?:' + w.location.origin.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + ')?' + proxyPath.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '(?:/|\\?|$)'));
      sdk.init({
        dsn: config.dsn, environment: config.environment || 'production', release: config.release || 'b2b-theme@embellishments',
        sendDefaultPii: false, enableLogs: true, enableMetrics: false, maxBreadcrumbs: 0, maxValueLength: 8192,
        integrations: [sdk.browserTracingIntegration({ instrumentPageLoad: false, instrumentNavigation: false, enableInp: false })],
        tracePropagationTargets: targets,
        tracesSampler: function () { return 1; },
        beforeSend: scrub, beforeSendTransaction: scrub, beforeSendSpan: scrubSpan,
        beforeSendLog: function (entry) {
          var data = attrs(entry.attributes);
          ['sentry.environment', 'sentry.release', 'sentry.sdk.name', 'sentry.sdk.version'].forEach(function (key) {
            var value = entry.attributes && entry.attributes[key];
            if (typeof value === 'string' && /^[a-zA-Z0-9_.:@/ -]{1,120}$/.test(value)) data[key] = value;
          });
          return Object.assign({}, entry, { message: data.operation || 'storefront.log', attributes: data });
        }
      });
      enabled = true;
      sdk.setTags(attrs({ app_component: 'storefront', customer_role: config.customerRole, buying_mode: config.buyingMode, customer_id: config.customerId }));
      if (/^\d+$/.test(String(config.customerId || ''))) sdk.setUser({ id: String(config.customerId) });
    }
  } catch (_) { enabled = false; }
  // Save the SDK-instrumented fetch after initialization. SDK absence keeps the native behavior.
  var nativeFetch = w.fetch && w.fetch.bind(w);
  function log(level, operation, data) {
    try {
      if (!enabled || !sdk.logger) return;
      sdk.logger[level](operation, attrs(Object.assign({ app_component: 'storefront', customer_role: config.customerRole, buying_mode: config.buyingMode, customer_id: config.customerId, operation: operation }, data)));
    } catch (_) {}
  }
  function report(error, operation, data) {
    try {
      if (!enabled || (seen && error && typeof error === 'object' && seen.has(error))) return;
      if (seen && error && typeof error === 'object') seen.add(error);
      // HTTP outcomes are logged at the request boundary. Catches also cover JS/JSON failures.
      log(error && (error.name === 'TypeError' || error.name === 'SyntaxError') ? 'warn' : 'info', operation, Object.assign({ outcome: 'fallback', fallback: true, error_details: errorDetails(error) }, data));
      if (error && (error.name === 'TypeError' || error.name === 'SyntaxError')) {
        sdk.withScope(function (scope) { scope.setTags(attrs(Object.assign({ operation: operation }, data))); sdk.captureException(error); });
      }
    } catch (_) {}
  }
  function operationFor(url) {
    var path = route(url);
    var match = path.match(/\/(embellishments|quotes|quote|draft-orders|tax|pricing|credit|buying-mode|master-purchaser-context)(?:\/(.*))?$/);
    return match ? match[1].replace(/-/g, '_') + '.' + (match[2] || 'load').replace(/[:/\-]/g, '_') : /\/cart(?:[/.]|$)/.test(path) ? 'cart.request' : 'storefront.request';
  }
  function uuid() {
    if (w.crypto && w.crypto.randomUUID) return w.crypto.randomUUID();
    if (!w.crypto || !w.crypto.getRandomValues) return '';
    var bytes = new Uint8Array(16); w.crypto.getRandomValues(bytes); bytes[6] = (bytes[6] & 15) | 64; bytes[8] = (bytes[8] & 63) | 128;
    var hex = Array.from(bytes, function (byte) { return byte.toString(16).padStart(2, '0'); }).join('');
    return hex.slice(0, 8) + '-' + hex.slice(8, 12) + '-' + hex.slice(12, 16) + '-' + hex.slice(16, 20) + '-' + hex.slice(20);
  }
  function monitoredFetch(input, options, metadata) {
    if (!enabled) return nativeFetch(input, options);
    var url, requestId = '', nextInput = input, nextOptions = options;
    var operation = metadata && metadata.operation || 'storefront.request';
    var data = attrs(metadata || {});
    try {
      url = new URL(typeof input === 'string' ? input : input.url, w.location.href);
      operation = metadata && metadata.operation || operationFor(url.href);
      data = attrs(Object.assign({}, data, { operation: operation, route: route(url.href), method: (options && options.method) || (input && input.method) || 'GET' }));
      data.workflow = operation.split('.')[0];
      if (target(url)) {
        requestId = uuid();
        data.request_id = requestId;
        if (url.origin === w.location.origin) {
          // Shopify signs the proxy query. Custom headers may be stripped by the proxy.
          if (requestId && typeof input === 'string') { url.searchParams.set('_b2b_request_id', requestId); nextInput = url.href; }
        } else if (requestId) {
          var headers = new Headers((options && options.headers) || (input && input.headers) || {});
          headers.set('X-Request-ID', requestId);
          nextOptions = Object.assign({}, options, { headers: headers });
        }
      }
    } catch (_) { /* Invalid or unusual fetch inputs retain their original behavior. */ }
    var started = Date.now();
    function perform() {
      return nativeFetch(nextInput, nextOptions).then(function (response) {
        var resultData = Object.assign({}, data, { status_code: response.status, duration_ms: Date.now() - started });
        log(response.status >= 500 ? 'error' : response.ok ? 'info' : 'info', operation, Object.assign(resultData, { outcome: response.ok ? 'completed' : response.status >= 500 ? 'failed' : 'rejected' }));
        // These small JSON responses can fail at HTTP 200, including unawaited preset saves.
        if (url && target(url) && /\/embellishments\/(price|presets(?:\/use)?)$/.test(url.pathname) && response.ok && response.clone) {
          try { response.clone().json().then(function (body) {
            if (body.success === false) log('warn', operation, Object.assign({}, resultData, { outcome: 'failed', reason_code: 'unsuccessful_response' }));
            var price = body.pricing || body.data || body;
            if (price.status === 'NEEDS_QUOTE') log('info', operation, Object.assign({}, resultData, { pricing_status: 'NEEDS_QUOTE', reason_code: 'manual_quote' }));
          }).catch(function () {}); } catch (_) {}
        }
        return response;
      }, function (error) {
        if (error && error.name === 'AbortError') { log('info', operation, Object.assign({}, data, { outcome: 'cancelled' })); throw error; }
        try {
          if (!seen || !seen.has(error)) {
            if (seen && error && typeof error === 'object') seen.add(error);
            sdk.withScope(function (scope) { scope.setTags(attrs(Object.assign({}, data, { operation: operation }))); sdk.captureException(error); });
            log('error', operation, Object.assign({}, data, { outcome: 'network_failed', duration_ms: Date.now() - started, error_details: errorDetails(error) }));
          }
        } catch (_) {}
        throw error;
      });
    }
    // Keep the same returned Response and application rejection. Tracing adds no business behavior.
    var invoked = false;
    try { return sdk.startSpan({ name: operation, op: 'b2b.workflow', attributes: data }, function () { invoked = true; return perform(); }); }
    catch (error) { if (invoked) throw error; return perform(); }
  }
  w.B2BMonitoring = { fetch: monitoredFetch, report: report, log: log, scrub: scrub, enabled: enabled };
})(window);
